export default "__VITE_ASSET__vKTwMn7d__"